import React, { FC } from 'react';
import { Container } from './styles';
import { Props } from './types';

const FormContainer: FC<Props> = ({ children, ...rest }) => (
  <Container {...rest}>{children}</Container>
);

export default FormContainer;
